// extracted by mini-css-extract-plugin
export default {"SectionGate":"SectionGate3hunO41Nh9Ua","SectionGate-content":"SectionGate-content200UkNpNBC0A"};